module.exports = __webpack_public_path__ + "img/recent.826c5330.svg";